import axios from '../http'
import { ACTIVE_MESSAGES, MESSAGES } from '../endpoints'

const getActiveMessages = id => axios.get(`${ACTIVE_MESSAGES}/${id}`)
const sendMessages = data => axios.post(MESSAGES, data)

export default {
  getActiveMessages,
  sendMessages
}



// WEBPACK FOOTER //
// ./src/repository/api/messages.js